<template>
  <div class="portlet">
    <div class="portlet-title" v-if="$slots.title">
      <div class="caption">
        <slot name="title"></slot>
      </div>
    </div>
    <div class="portlet-body" ref="portletBody">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
  import BScroll from 'better-scroll'
  import {SCROLL_CONFIG} from "../../store/constant";

  export default {
    name: "Portlet"
    , props: {
      scroll: {
        type: Boolean
        , default: false
      }
    }
    , mounted() {
      if (this.scroll)
        new BScroll(this.$refs.portletBody, SCROLL_CONFIG)
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/portlet";
</style>